import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';

const ColList = ({ items, displayField, separator = ' - ', height = 200 }) => {
    const getLabel = (item) => {
        if (Array.isArray(displayField)) {
            return displayField.map(field => item[field]).join(separator);
        }
        return item[displayField];
    };

    return (
        <div style={{ maxHeight: height, overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px' }}>
            <List disablePadding>
                {items.map((item, index) => (
                    <ListItem key={index} divider>
                        <ListItemText primary={getLabel(item)} />
                    </ListItem>
                ))}
            </List>
        </div>
    );
};

export default ColList;
